import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ValidationErrors } from '@angular/forms';
import Swal from 'sweetalert2';

import { parseDate, checkMobileView, queryString } from '@teem/helpers/functions';

import { ExpenseService } from '@teem/services/expense.service';
import { LoaderService } from '@teem/services/loader.service';
import { ExpenseForm } from '@teem/model-forms/expense-form';
import { expense as ExpenseApi, invoice as InvoiceApi } from '@teem/constants/api';
import { messages as i18n } from '@teem/constants/messages';
import { EXPENSE_TYPES } from '@teem/constants/expenses';
import { Expense } from '@teem/models/expense';


@Component({
  selector: 'app-edit-expense-modal',
  templateUrl: './edit-expense-modal.component.html',
  styleUrls: ['./edit-expense-modal.component.scss']
})
export class EditExpenseModalComponent implements OnInit {
  @Input() invoicesList: Array<any>;
  @Input() isProPlan: any;
  @Input() expenseInfo: any;
  @Output() onLoad: EventEmitter<any> = new EventEmitter();
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  @ViewChild('receiptInvoicePhoto') myPond: any;
  expenseTypes: Array<object> = EXPENSE_TYPES;
  editExpenseForm: FormGroup;
  submitted: boolean = false;
  selectedType: string = null;
  invoiceListApi: string = InvoiceApi.list;
  receiptFile: any;
  formData = new FormData();

  pondOptions = {
    multiple: false,
    allowReplace: false,
    allowRemove: true,
    allowImageResize: true,
    allowImagePreview: true,
    imageResizeMode: 'cover',
    acceptedFileTypes: 'image/png, image/jpeg, image/gif',
    labelIdle: `<span class="icon-upload"></span>`
  };

  constructor(
    private fb: FormBuilder,
    private loaderService: LoaderService,
    private expenseService: ExpenseService,
    private el: ElementRef,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.editExpenseForm = this.fb.group(new ExpenseForm(new Expense(this.expenseInfo)));
    this.editExpenseForm.controls['net_vat_amount_percent'].disable();

    this.onSelectCategory(this.expenseInfo.expense_category);
    if (this.expenseInfo.attachment != null) {
      this.receiptFile = this.expenseInfo.attachment;
    }
    
    if (this.expenseInfo.vat_include)
      this.updateCast(this.expenseInfo.vat_percentage, this.expenseInfo.taxable_amount);

    if (this.expenseInfo.expense_category)
      this.selectedType = this.expenseInfo.expense_category.replace(/_/g, " ");
  }

  get f() {
    return this.editExpenseForm.controls;
  }

  updateCast(vat_percentage, taxable_amount) {
    this.editExpenseForm.controls.net_vat_amount_percent.setValue(((vat_percentage / 100) * taxable_amount).toFixed(2));
    this.editExpenseForm.controls.cost.setValue(taxable_amount);
  }

  changeVatInclude(vat_include) {
    ['receipt_number', 'vat_number', 'vendor_name', 'vat_percentage', 'taxable_amount'].forEach((field: string) => {
      this.editExpenseForm.get(field).setValue(null);
      this.editExpenseForm.get(field).clearValidators();      
      this.editExpenseForm.get(field).updateValueAndValidity();
    });

    this.editExpenseForm.controls.cost.setValidators([Validators.required, Validators.min(0.01)]);
    this.editExpenseForm.controls.cost.updateValueAndValidity();
    
    if (vat_include) {
      ['receipt_number', 'vat_number', 'vendor_name', 'vat_percentage', 'taxable_amount'].forEach((field: string) => {
        if (field == 'vat_percentage') 
          this.editExpenseForm.get(field).setValidators([Validators.required, Validators.min(0), Validators.max(100)]);

        this.editExpenseForm.get(field).setValidators([Validators.required]);
        this.editExpenseForm.get(field).updateValueAndValidity();
      });

      this.editExpenseForm.controls.cost.setValue(null);
      this.editExpenseForm.controls.cost.clearValidators();
      this.editExpenseForm.controls.cost.updateValueAndValidity();
    }
  }

  onSelectCategory(value: any) {
    let $this = this;
    this.expenseTypes.forEach(function (type: any) {
      type.categories.forEach(function (category) {
        if (category.value == value) {
          $this.selectedType = type.label;
          $this.editExpenseForm.get('expense_category').setValue(type.value);
        }
      });
    });
  }

  pondHandleInit() {
    // console.log('FilePond has initialised', this.myPond);
  }

  pondHandleAddFile(event: any) {
    // console.log(this.myPond);
    if (this.formData.has('receipt_file')) {
      this.formData.set('receipt_file', event.file.file);
    } else {
      this.formData.append('receipt_file', event.file.file);
    }
  }


  onSubmitEditExpense(form: FormGroup) {
    form.get('submitted').setValue(true);
    if (form.valid) {
      this.loaderService.startLoading();

      let fd = form.value;
      fd.vat_include = fd.vat_include ? 1 : 0;
      fd.expense_date = parseDate(fd.expense_date);
      if (!fd.cost)
        fd.cost = fd.taxable_amount;

      delete fd.edit;
      delete fd.submitted;

      if (this.formData.has('receipt_file')) {
        fd.receipt_file = this.formData.get('receipt_file');
      }

      this.expenseService.update(fd, { headers: { 'Content-Type': 'multipart/form-data' } }).subscribe(data => {

        this.loaderService.stopLoading();

        Swal.fire(i18n.done, i18n.expense.expense_updated, 'success');
        form.get('submitted').setValue(false);

        this.activeModal.close(data);
      }, err => {
        this.loaderService.stopLoading();

        // Set server side error
        if (err.status === 422) {
          if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
            let validationErrors = err.error.errors;
            Object.keys(validationErrors).forEach((prop) => {
              form.get(prop)?.setErrors({
                serverError: validationErrors[prop]
              })
            })
          }
        }

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }
}
